import { combineReducers } from "redux";
import NCDIPOReducer from "./NCDIPOReducer";
export default combineReducers({
    NCDIPOReducer,
});
